export default {
    name: 'ຊື່',
    tel: 'ໂທລະສັບ',
    save: 'ບັນທຶກ',
    confirm: 'ຢືນຢັນ',
    cancel: 'ຍົກເລີກ',
    delete: 'ລຶບ',
    complete: 'ສໍາເລັດ',
    loading: 'ກຳລັງໂຫຼດ...',
    telEmpty: 'ກະລຸນາໃສ່ເບີໂທລະສັບ',
    nameEmpty: 'ກະລຸນາໃສ່ຊື່',
    nameInvalid: 'ຮູບແບບຊື່ບໍ່ຖືກຕ້ອງ',
    confirmDelete: 'ທ່ານແນ່ໃຈທີ່ຈະລຶບແທ້ບໍ່?',
    telInvalid: 'ເບີໂທລະສັບບໍ່ຖືກຕ້ອງ',
    vanCalendar: {
        end: 'ສິ້ນສຸດ',
        start: 'ເລີ່ມຕົ້ນ',
        title: 'ປະຕິທິນ',
        startEnd: 'ເລີ່ມ/ສິ້ນສຸດ',
        weekdays: ['ທ.', 'ຈ.', 'ອຄ.', 'ພຸ.', 'ພຫ.', 'ສກ.', 'ເສ.'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `ເລືອກບໍ່ເກີນ ${maxRange} ມື້`,
    },
    vanCascader: {
        select: 'ເລືອກ',
    },
    vanContactCard: {
        addText: 'ເພີ່ມຂໍ້ມູນຕິດຕໍ່',
    },
    vanContactList: {
        addText: 'ເພີ່ມຜູ້ຕິດຕໍ່ໃໝ່',
    },
    vanPagination: {
        prev: 'ກ່ອນໜ້າ',
        next: 'ຕໍ່ໄປ',
    },
    vanPullRefresh: {
        pulling: 'ດຶງເພື່ອເພີ່ມໃໝ່...',
        loosing: 'ປ່ອຍເພື່ອເພີ່ມໃໝ່...',
    },
    vanSubmitBar: {
        label: 'ລວມ:',
    },
    vanCoupon: {
        unlimited: 'ບໍ່ຈໍາກັດ',
        discount: (discount) => `ຫຼຸດ ${discount * 10}%`,
        condition: (condition) => `ຢ່າງໜ້ອຍ ${condition}`,
    },
    vanCouponCell: {
        title: 'ຄູປອງ',
        tips: 'ບໍ່ມີຄູປອງ',
        count: (count) => `ທ່ານມີ ${count} ຄູປອງ`,
    },
    vanCouponList: {
        empty: 'ບໍ່ມີຄູປອງ',
        exchange: 'ແລກປ່ຽນ',
        close: 'ປິດ',
        enable: 'ມີຢູ່',
        disabled: 'ບໍ່ມີ',
        placeholder: 'ລະຫັດຄູປອງ',
    },
    vanAddressEdit: {
        area: 'ພື້ນທີ່',
        postal: 'ໄປສະນີ',
        areaEmpty: 'ກະລຸນາເລືອກພື້ນທີ່ຮັບ',
        addressEmpty: 'ທີ່ຢູ່ບໍ່ສາມາດຫວ່າງໄດ້',
        postalEmpty: 'ລະຫັດໄປສະນີບໍ່ຖືກຕ້ອງ',
        defaultAddress: 'ຕັ້ງເປັນທີ່ຢູ່ເລີ່ມຕົ້ນ',
        telPlaceholder: 'ໂທລະສັບ',
        namePlaceholder: 'ຊື່',
        areaPlaceholder: 'ພື້ນທີ່',
    },
    vanAddressEditDetail: {
        label: 'ທີ່ຢູ່',
        placeholder: 'ທີ່ຢູ່',
    },
    vanAddressList: {
        add: 'ເພີ່ມທີ່ຢູ່ໃໝ່',
    },
}